<template>
  <va-modal
    v-model="showModal"
    id="clonePermissionsModal"
    ref="clonePermissionsModal"
    okClass="btn btn-micro btn-primary"
    :okText="$t('modals.buttons.save')"
    :cancelText="$t('modals.buttons.cancel')"
    @ok="performSave"
    @cancel="performCancel"
    :okToClose="false"
    :okDisabled="canSubmitForm">

    <div slot="header" class="modal-title">
      <span >{{ $t('users.clone.title') }}</span>
    </div>

    <clone-user-form
      :from="from"
      :to="to"
      :cloneForm.sync="form"
      :options="options">
    </clone-user-form>

  </va-modal>
</template>
<script>
import CloneUserForm from './CloneUserForm'
import { UserService } from '@/api/AuthService'
export default {
  components: {
    CloneUserForm
  },
  props: {
    from: {
      type: Object,
      required: false
    },
    to: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      showModal: false,
      form: {
        fromUser: null,
        toUser: null
      },
      options: {
        access: 2
      },
      isSubmitting: false
    }
  },
  created () {
    this.updateUIFields()
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    updateUIFields: function () {
      if (this.from) {
        this.form.fromUser = this.from
      }
      if (this.to) {
        this.form.toUser = this.to
      }
    },
    performSave: function () {
      this.isSubmitting = true
      UserService.clonePermissions(this.form.fromUser, this.form.toUser)
        .then((response) => {
          this.showToast(this.$t('users.clone.success_msg'), this.$store.state.successToastOptions)
          setTimeout(() => {
            this.$emit('modalClosed')
          }, 500)
        }).catch((err) => {
          this.showToast(this.$t('users.clone.error_msg'), this.$store.state.errorToastOptions)
          console.log(err)
        }).finally(() => {
          this.isSubmitting = false
        })
    },
    performCancel: function () {
      setTimeout(() => {
        this.$emit('modalClosed')
      }, 500)
    }
  },
  computed: {
    canSubmitForm: function () {
      return (!this.form.fromUser || !this.form.toUser) && !this.isSubmitting
    }
  }
}
</script>
